module.exports = __webpack_public_path__ + "img/step5.ed09a325.png";